import React from "react";
import Header from "../components/Header.js";
import Middle from "../components/Middle.js";
import Mission from "../components/Mission.js";
import Footer from "../components/Footer.js"; // import the Footer component


const Home = () => {
return (
	<div>
              <Header />
              <Mission />
              <Middle />
       </div>
);
};

export default Home;

// import React from "react";
// import Header from "../components/Header.js";
// import Middle from "../components/Middle.js";
// import Mission from "../components/Mission.js";
// import Footer from "../components/Footer.js"; // import the Footer component

// const Home = () => {
// return (
// 	<p>
//        <Header />
//        <br></br>
//        <Mission />
//        <br></br>
//        <Middle />
//        <br></br>
//        <Footer />
// 	</p>
// );
// };

// export default Home;


